/**
 * Shared formatters for the billing screens. Centralised here so the
 * forms, the add-ons card and the company dashboard render dates and
 * numbers consistently.
 */

/** Long human date, e.g. "14 de junio de 2026". Returns "—" when empty. */
export function formatLongDate(value?: string): string {
  if (!value) {
    return '—';
  }
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString('es-AR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/** Compact date, e.g. "14 jun 2026". Returns the raw value if unparsable. */
export function formatShortDate(value: string): string {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString('es-AR', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
}

/** Thousands-separated number in es-AR locale. */
export function formatNumber(value: number): string {
  return value.toLocaleString('es-AR');
}
